import React, { useEffect, useRef, useState } from 'react';
import Scene from './viewer_scripts/scene';
import Marzipano from 'marzipano';
import Details from './viewer_scripts/hotspots/details';
import Move from './viewer_scripts/hotspots/move';
import ModalDetails from './viewer_scripts/modals/details';
import SceneList from './viewer_scripts/sceneList';
import Modal from './viewer_scripts/modal';
import PanelSterowania from './panel';
import SceneClass from './viewer_scripts/classScene';
import ModalImageFull from './viewer_scripts/modals/fullImage';
import { Medal1 } from './models/medal1.jsx';
import { Medal2 } from './models/medal2.jsx';
import { Medal3 } from './models/medal3.jsx';
import { Medal4 } from './models/medal4.jsx';
import { Medal5 } from './models/medal5.jsx';
import { Banknot } from './models/Banknot.jsx';


const MarzipanoViewer = () => {
  const [modal, setModal] = useState(null);
  const [scenes, setScenes] = useState([])
  const [actualScene, setActualScene] = useState(null)
  const [testElem, setTestElem] = useState(null)

  const [liveMove, setliveMove] = useState({ yaw: 0, pitch: 0 })

  const [viewer, setViewer] = useState(null)

  useEffect(() => {


    const viewer = new Marzipano.Viewer(document.getElementById("marzipano"));

    const pamiec1 = new Scene({ setActual: setActualScene, name: "Izba\u00A0Pamięci", image: "ViewsImages/izba1.jpg", viewer: viewer, cameraStart: { pitch: 0, yaw: 0 }, visible_list: true });
    // const pamiec2 = new Scene({ setActual: setActualScene, name: "Izba\u00A0Pamięci", image: "ViewsImages/izba2.jpg", viewer: viewer });
    const izba_korytarz = new Scene({ setActual: setActualScene, name: "Korytarz", image: "ViewsImages/izba_wejscie.jpg", viewer: viewer });
    const ukryty_pokoj = new Scene({ setActual: setActualScene, name: "Korytarz", image: "ViewsImages/korytarz_izba_lewo.jpg", viewer: viewer });
    const winda = new Scene({ setActual: setActualScene, name: "Winda", image: "ViewsImages/winda.jpg", viewer: viewer });

    const puchary = new Scene({cameraStart:{yaw: -1.897982763362707, pitch: 0.06449358491642698}, setActual: setActualScene, name: "Korytarz", image: "ViewsImages/puchary.jpg", viewer: viewer });
    const piwnica = new Scene({ setActual: setActualScene, name: "Tenis\u00A0stołowy", image: "ViewsImages/pingpong.jpg", viewer: viewer });
    const piwnica2 = new Scene({ setActual: setActualScene, name: "Piwnica", image: "ViewsImages/piwnica2.jpg", viewer: viewer });

    const parter_schody = new Scene({ setActual: setActualScene, name: "Korytarz", image: "ViewsImages/parter_schody.jpg", viewer: viewer });
    const korytarz_odreaguj = new Scene({ setActual: setActualScene, name: "Korytarz", image: "ViewsImages/odreaguj.jpg", viewer: viewer });
    const wejscie = new Scene({ setActual: setActualScene, name: "Wejście", image: "ViewsImages/wejscie.jpg", viewer: viewer });
    const podworko = new Scene({ setActual: setActualScene, name: "Dziedziniec", image: "ViewsImages/podworko.jpg", viewer: viewer });
    const mostkoniec = new Scene({ setActual: setActualScene, name: "Korytarz", image: "ViewsImages/mostkoniec.jpg", viewer: viewer });
    const korytarz_sala_gimastyczna = new Scene({ setActual: setActualScene, name: "Korytarz", image: "ViewsImages/sala_gimastyczna_korytarz.jpg", viewer: viewer });
    const sala_gimastyczna = new Scene({ setActual: setActualScene, name: "Duża\u00A0sala\u00A0gimastyczna", image: "ViewsImages/sala_gimastyczna.jpg", viewer: viewer });
    const swietlica = new Scene({ setActual: setActualScene, name: "Korytarz", image: "ViewsImages/swietlica_korytarz.jpg", viewer: viewer });
    const pietro_korytarz = new Scene({ setActual: setActualScene, name: "Korytarz", image: "ViewsImages/korytarz_pietro_1.jpg", viewer: viewer });
    const pietro_korytarz2 = new Scene({ setActual: setActualScene, name: "Korytarz", image: "ViewsImages/pietro_korytarz_2.jpg", viewer: viewer });
    const pietro_korytarz3 = new Scene({cameraStart :{ yaw: 2.9739771848156202, pitch: 0.14237515681338664 }, setActual: setActualScene, name: "Korytarz", image: "ViewsImages/korytarz212.jpg", viewer: viewer });
    const pietro_korytarz4 = new Scene({ setActual: setActualScene, name: "Korytarz", image: "ViewsImages/schody_pietro_1.jpg", viewer: viewer });
    const pietro_korytarz5 = new Scene({ setActual: setActualScene, name: "Korytarz", image: "ViewsImages/korytarz215.jpg", viewer: viewer });




    //sale
    const swietlica1 = new SceneClass({ setActual: setActualScene, name: "Świetlica\u00A01", image: "ViewsImages/swietlica1.jpg", viewer: viewer, goBack: swietlica, details: [{ name: "Miejsce", desc: "Świetlica" }] });

    const swietlica2 = new SceneClass({ setActual: setActualScene, name: "Świetlica\u00A02", image: "ViewsImages/swietlica3.jpg", viewer: viewer, goBack: swietlica, details: [{ name: "Miejsce", desc: "Świetlica" }] });

    const swietlica3 = new SceneClass({ setActual: setActualScene, name: "Świetlica\u00A03", image: "ViewsImages/swietlica2.jpg", viewer: viewer, goBack: swietlica, details: [{ name: "Miejsce", desc: "Świetlica" }] });

    const chemia = new SceneClass({ goBack: ukryty_pokoj, setActual: setActualScene, name: "204\u00A0-\u00A0Chemia", image: "ViewsImages/chemia.jpg", viewer: viewer, goBack: ukryty_pokoj, details: [{ name: "Miejsce", desc: "Sala chemiczna" }] });

    const historia = new SceneClass({ goBack: pietro_korytarz, setActual: setActualScene, name: "208\u00A0-\u00A0Historia", image: "ViewsImages/cos.jpg", viewer: viewer, details: [{ name: "Miejsce", desc: "Sala historyczna" }] });

    const mala_sala = new SceneClass({ goBack: mostkoniec, setActual: setActualScene, name: "Mała\u00A0sala\u00A0gimastyczna", image: "ViewsImages/mala_sala_gimastyczna.jpg", viewer: viewer, goBack: mostkoniec, details: [{ name: "Miejsce", desc: "Mała sala gimastyczna" }] });

    const sala_fitnes = new SceneClass({ goBack: sala_gimastyczna, setActual: setActualScene, name: "Sala\u00A0Crossfit", image: "ViewsImages/fitnes_duza_sala.jpg", viewer: viewer, details: [{ name: "Miejsce", desc: "Sala Crossfit" }] });

    const przyszlosc = new SceneClass({ goBack: pietro_korytarz4, setActual: setActualScene, name: "Laboratoria\u00A0Przyszłości", image: "ViewsImages/pracownia_przyszlosci.jpg", viewer: viewer, details: [{ name: "Miejsce", desc: "Laboratoria Przyszłości" }] });

    const stolowka = new SceneClass({ goBack: wejscie, setActual: setActualScene, name: "Stołówka", image: "ViewsImages/stolowka.jpg", viewer: viewer, details: [{ name: "Miejsce", desc: "Stołówka szkolna" }] });

    const psycholog = new SceneClass({ goBack: puchary, setActual: setActualScene, name: "Logopeda", image: "ViewsImages/psycholog.jpg", viewer: viewer, details: [{ name: "Miejsce", desc: "Sala logopedyczna" }] });

    const korekcja = new SceneClass({ goBack: piwnica, setActual: setActualScene, name: "Sala\u00A0korekcyjna", image: "ViewsImages/korekcja_przeszkody.jpg", viewer: viewer, details: [{ name: "Miejsce", desc: "Sala gimnastyki korekcyjnej" }] });

    const sala_fitness = new SceneClass({ setActual: setActualScene, name: "Sala\u00A0Fitness", image: "ViewsImages/fittnes.jpg", viewer: viewer, details: [{ name: "Miejsce", desc: "Sala Fitness" }] });//brak powrotu

    const sala_odreaguj = new SceneClass({ goBack: korytarz_odreaguj, setActual: setActualScene, name: "Sala\u00A0terapeutyczna", image: "ViewsImages/odraguj_sala.jpg", viewer: viewer, details: [{ name: "Miejsce", desc: "Sala terapeutyczna" }] });

    const piwnica_angielski = new SceneClass({ goBack: piwnica2, setActual: setActualScene, name: "8\u00A0-\u00A0Język\u00A0angielski", image: "ViewsImages/angielski_piwnica.jpg", viewer: viewer, details: [{ name: "Miejsce", desc: "Sala języka angielskiego" }] });

    const piwnica_informatyka = new SceneClass({ goBack: piwnica2, setActual: setActualScene, name: "7\u00A0-\u00A0Informatyka", image: "ViewsImages/piwnica_informatyka.jpg", viewer: viewer, details: [{ name: "Miejsce", desc: "Sala informatyczna" }] });

    const piwnica_sala = new SceneClass({ goBack: piwnica2, setActual: setActualScene, name: "9\u00A0-\u00A0Matematyka", image: "ViewsImages/piwnica_sala.jpg", viewer: viewer, details: [{ name: "Miejsce", desc: "Sala matematyczna" }] });

    const sala_studia = new SceneClass({ goBack: puchary, setActual: setActualScene, name: "S4\u00A0-\u00A0Matematyka", image: "ViewsImages/sala_studia.jpg", viewer: viewer, details: [{ name: "Miejsce", desc: "Sala matematyczna" }] });

    const biblioteka = new SceneClass({ goBack: puchary, setActual: setActualScene, name: "Biblioteka", image: "ViewsImages/biblioteka.jpg", viewer: viewer, details: [{ name: "Miejsce", desc: "Biblioteka i czytelnia" }] });

    const polski_parter = new SceneClass({ goBack: korytarz_odreaguj, setActual: setActualScene, name: "124a\u00A0-\u00A0Język\u00A0polski", image: "ViewsImages/polski.jpg", viewer: viewer, details: [{ name: "Miejsce", desc: "Sala języka polskiego" }] });

    const sala_mamy = new SceneClass({ goBack: pietro_korytarz4, setActual: setActualScene, name: "220\u00A0-\u00A0Język\u00A0polski", image: "ViewsImages/polski-120.jpg", viewer: viewer, details: [{ name: "Miejsce", desc: "Sala języka polskiego" }] });


    const strefa_relaksu = new SceneClass({ goBack: wejscie, setActual: setActualScene, name: "Strefa\u00A0relaksu", image: "ViewsImages/strefa_relaksu.jpg", viewer: viewer, details: [{ name: "Przeznaczenie", desc: "Miejsce do odpoczynku dla ucznów i gości" }] });


    const eko_pracowania = new SceneClass({ goBack: pietro_korytarz, setActual: setActualScene, name: "Eko\u00A0pracowania", image: "ViewsImages/eko_pracownia.jpg", viewer: viewer, details: [{ name: "Miejsce", desc: "Eko pracownia" }] });

    const sala_210 = new SceneClass({ goBack: pietro_korytarz, setActual: setActualScene, name: "210\u00A0-\u00A0Edukacja\u00A0wczesnoszkolna", image: "ViewsImages/sala_210.jpg", viewer: viewer, details: [{ name: "Miejsce", desc: "Sala edukacji wczesnoszkolnej" }] });

    const sala_205 = new SceneClass({ goBack: ukryty_pokoj, setActual: setActualScene, name: "205\u00A0-\u00A0Matematyka", image: "ViewsImages/sala_205.jpg", viewer: viewer, details: [{ name: "Miejsce", desc: "Sala matematyczna" }] });
    const sala_212 = new SceneClass({ goBack: pietro_korytarz3, setActual: setActualScene, name: "212\u00A0-\u00A0Edukacja\u00A0wczesnoszkolna", image: "ViewsImages/sala_212.jpg", viewer: viewer, details: [{ name: "Miejsce", desc: "Sala edukacji wczesnoszkolnej" }] });
    const sala_215 = new SceneClass({ goBack: pietro_korytarz5, setActual: setActualScene, name: "215\u00A0-\u00A0Edukacja\u00A0wczesnoszkolna", image: "ViewsImages/sala_215.jpg", viewer: viewer, details: [{ name: "Miejsce", desc: "Sala edukacji wczesnoszkolnej" }] });




    setScenes([
      { scene: pamiec1, hint: pamiec1.name },
      { scene: przyszlosc, hint: przyszlosc.name },
      { scene: piwnica, hint: piwnica.name },
      { scene: korekcja, hint: korekcja.name },
      { scene: sala_gimastyczna, hint: sala_gimastyczna.name },
      { scene: mala_sala, hint: mala_sala.name },
      { scene: sala_fitness, hint: sala_fitness.name },
      { scene: sala_fitnes, hint: sala_fitnes.name },
      { scene: swietlica, hint: "Świetlica" },
      { scene: sala_odreaguj, hint: sala_odreaguj.name },
      { scene: sala_mamy, hint: sala_mamy.name },
      { scene: sala_212, hint: "Edukacja wczesnoszkolna" },
    ])


    // pamiec2.addHotspot(new Move(pamiec1, { yaw: 3, pitch: -.05 }, { yaw: -.1 }));
    // pamiec1.addHotspot(new Move(pamiec2, { yaw: -.1, pitch: -.05 }, { yaw: 3.20, pitch: 0.1 }));


    pamiec1.addHotspot(new Move(izba_korytarz, { yaw: 2.91, pitch: -0.05 }));

    izba_korytarz.addHotspot(new Move(pamiec1, { yaw: 3.1324494047267137, pitch: 0.12827376088770848 }));
    izba_korytarz.addHotspot(new Move(ukryty_pokoj, { yaw: -1.7609382552727109, pitch: 0.055763790317872264 }), false);
    izba_korytarz.addHotspot(new Move(puchary, { yaw: 0.13370256805600533, pitch: 0.13992615709187461 }, {}, "Parter"));
    izba_korytarz.addHotspot(new Move(pietro_korytarz, { yaw: 1.695665067218446, pitch: -0.01779648410282242 }), false);

    ukryty_pokoj.addHotspot(new Move(izba_korytarz, { yaw: -2.9009571436749084, pitch: 0.00876690086364107 }), false);
    ukryty_pokoj.addHotspot(new Move(winda, { yaw: -0.03629023365434669, pitch: -0.018881356574373953 }));
    ukryty_pokoj.addHotspot(new Move(chemia, { yaw: -1.556369382903781, pitch: 0.03352193420356777 }));
    ukryty_pokoj.addHotspot(new Move(sala_205, { yaw: -0.45729527894454236, pitch: -0.0147431427125608 }));

    puchary.addHotspot(new Move(winda, { yaw: 1.5858286916291897, pitch: -0.052398633577349614 }));
    puchary.addHotspot(new Move(biblioteka, { yaw: 2.126957617700242, pitch: 0.047257428036596494 }));
    puchary.addHotspot(new Move(psycholog, { yaw: -1.371869613245435, pitch: 0.061832368493131895 }));
    puchary.addHotspot(new Move(sala_studia, { yaw: -1.8142500059961097, pitch: -0.04668628776163075 }));
    puchary.addHotspot(new Move(izba_korytarz, { yaw: -2.399971305860241, pitch: -0.11304624361911308 }, {}, "Piętro\u00A01"));
    puchary.addHotspot(new Move(piwnica, { yaw: -2.399971305860241, pitch: 0.11304624361911308 }));
    puchary.addHotspot(new Move(wejscie, { yaw: -0.01059070812699403, pitch: -0.0011509077947522428 }));


    piwnica.addHotspot(new Move(winda, { yaw: 1.3997760987887027, pitch: -0.006265793572911349 }));
    piwnica.addHotspot(new Move(puchary, { yaw: -1.9276421946960909, pitch: 0.05565990720456071 }, {}, "Piętro\u00A01"));
    piwnica.addHotspot(new Move(korekcja, { yaw: -1.6180716997684321, pitch: -0.01300817242934073 }));
    piwnica.addHotspot(new Move(sala_fitness, { yaw: -0.19000191370887265, pitch: -0.008301381617325632 }));

    sala_fitness.addHotspot(new Move(piwnica2, { yaw: -2.1704185026213025, pitch: -0.06346413029869247 }));
    sala_fitness.addHotspot(new Move(piwnica, { yaw: -2.150374409352553, pitch: 0.23616387739684086 }));

    piwnica2.addHotspot(new Move(piwnica_angielski, { yaw: 0.6906505144978894, pitch: -0.000812870936837129 }));
    piwnica2.addHotspot(new Move(piwnica_informatyka, { yaw: -0.009883945248128967, pitch: 0.022374814495982775 }));
    piwnica2.addHotspot(new Move(piwnica_sala, { yaw: -0.6368760031366065, pitch: 0.08137693581389804 }));
    piwnica2.addHotspot(new Move(parter_schody, { yaw: -2.0189105187693492, pitch: 0.010311320903868548 }, {}, "Piętro\u00A01"));
    piwnica2.addHotspot(new Move(sala_fitness, { yaw: -2.497320586417306, pitch: 0.002724313758875496 }));

    parter_schody.addHotspot(new Move(pietro_korytarz4, { yaw: -0.2098811263693451, pitch: -0.21477462374030232 }, {}, "Piętro\u00A01"));
    parter_schody.addHotspot(new Move(piwnica2, { yaw: 0.23406159802648752, pitch: 0.24574729188361744 }));
    parter_schody.addHotspot(new Move(korytarz_odreaguj, { yaw: 1.6753361866052296, pitch: 0.006703819679964695 }), false);
    parter_schody.addHotspot(new Move(wejscie, { yaw: 2.549301679619882, pitch: -0.0020130877644763956 }));
    parter_schody.addHotspot(new Move(mostkoniec, { yaw: -1.7932917881091441, pitch: 0.04038136406793669 }), false);

    korytarz_odreaguj.addHotspot(new Move(parter_schody, { yaw: 3.077024652307613, pitch: 0.014469079910996996 }), false);
    korytarz_odreaguj.addHotspot(new Move(sala_odreaguj, { yaw: 0.1683721775994087, pitch: -0.038889796946566 }));
    korytarz_odreaguj.addHotspot(new Move(polski_parter, { yaw: -2.0053885230749238, pitch: 0.0542028433212387 }));

    podworko.addHotspot(new Move(wejscie, { yaw: 0.02280462030175201, pitch: -0.15588320339516137 }));

    stolowka.addHotspot(new Move(wejscie, { yaw: 1.6767931313088322, pitch: 0.002562757834521534 }));

    wejscie.addHotspot(new Move(podworko, { yaw: -3.0875180219611895, pitch: 0.012108033979803423 }));
    wejscie.addHotspot(new Move(puchary, { yaw: -1.5249273786666713, pitch: 0.03804937705036693 }), false);
    wejscie.addHotspot(new Move(parter_schody, { yaw: 1.5172399697606203, pitch: -0.022117188899485996 }), false);
    wejscie.addHotspot(new Move(stolowka, { yaw: -0.16804484974465694, pitch: 0.06716292579930183 }));
    wejscie.addHotspot(new Move(strefa_relaksu, { yaw: 2.587501164835155, pitch: 0.024380722248269038 }));

    mostkoniec.addHotspot(new Move(mala_sala, { yaw: 1.4518500370830179, pitch: -0.05719127027651005 }));
    mostkoniec.addHotspot(new Move(korytarz_sala_gimastyczna, { yaw: 1.1729331376627172, pitch: 0.04914960650394384 }, {}, "Piwnica"));
    mostkoniec.addHotspot(new Move(parter_schody, { yaw: -0.08902550363816175, pitch: -0.04027739730238153 }), false);

    korytarz_sala_gimastyczna.addHotspot(new Move(sala_gimastyczna, { yaw: -2.8331103551339893, pitch: 0.005989567901366399 }));
    korytarz_sala_gimastyczna.addHotspot(new Move(mostkoniec, { yaw: 1.0102295609366276, pitch: -0.35464172685920303 }, {}, "Piętro\u00A01"));
    korytarz_sala_gimastyczna.addHotspot(new Move(swietlica, { yaw: -0.2740152157426792, pitch: 0.01220686861862319 }, {}, "Świetlica"));

    sala_gimastyczna.addHotspot(new Move(korytarz_sala_gimastyczna, { yaw: -2.1608367226976544, pitch: 0.016423315282143136 }, {}, "Wyjście"));
    sala_gimastyczna.addHotspot(new Move(sala_fitnes, { yaw: -1.2913773303870233, pitch: 0.028209290510957885 }));

    swietlica.addHotspot(new Move(swietlica1, { yaw: -0.28722961583472006, pitch: -0.006310066562678074 }));
    swietlica.addHotspot(new Move(swietlica2, { yaw: -1.3662191175435652, pitch: 0.048147079849869527 }));
    swietlica.addHotspot(new Move(swietlica3, { yaw: -1.5979461282838567, pitch: -0.036942728725730234 }));
    swietlica.addHotspot(new Move(korytarz_sala_gimastyczna, { yaw: 1.5564714684053316, pitch: -0.005799617494307796 }, {}, "Wyjście"));


    pietro_korytarz.addHotspot(new Move(izba_korytarz, { yaw: -0.9335578045448862, pitch: 0.04546559045522436 }), false);
    pietro_korytarz.addHotspot(new Move(pietro_korytarz3, { yaw: -2.6064815464039146, pitch: 0.02020681109246425 }), false);
    pietro_korytarz.addHotspot(new Move(historia, { yaw: 0.5206515698533121, pitch: 0.03566126628999555 }));
    pietro_korytarz.addHotspot(new Move(eko_pracowania, { yaw: 1.0292995333332229, pitch: 0.03566126628999555 }));
    pietro_korytarz.addHotspot(new Move(sala_210, { yaw: 2.5334019070192397, pitch: 0.03566126628999555 }));



    pietro_korytarz3.addHotspot(new Move(pietro_korytarz, { yaw: 1.6580855412986804, pitch: -0.017622916246644138 }), false);
    pietro_korytarz3.addHotspot(new Move(pietro_korytarz5, { yaw: -1.4719761918903984, pitch: 0.02529296599140274 }), false);
    pietro_korytarz3.addHotspot(new Move(sala_212, { yaw: 2.9739771848156202, pitch: 0.14237515681338664 }));


    pietro_korytarz2.addHotspot(new Move(pietro_korytarz5, { yaw: -2.014959118421311, pitch: 0.034403702985203566 }), false);
    pietro_korytarz2.addHotspot(new Move(pietro_korytarz4, { yaw: 2.996939035747915, pitch: 0.0015486432073323897 }), false);

    pietro_korytarz4.addHotspot(new Move(sala_mamy, { yaw: 1.7138545826650518, pitch: -0.01311932460730425 }));
    pietro_korytarz4.addHotspot(new Move(pietro_korytarz2, { yaw: -1.6461889452666458, pitch: 0.037410687186088865 }));
    pietro_korytarz4.addHotspot(new Move(parter_schody, { yaw: 0.05789219192346806, pitch: 0.09156945509734626 }));
    pietro_korytarz4.addHotspot(new Move(przyszlosc, { yaw: -2.4688815843086562, pitch: 0.12783268964829375 }));

    winda.addHotspot(new Move(ukryty_pokoj, { yaw: 0.02, pitch: 0.5 }, {}, "Piętro\u00A01"));
    winda.addHotspot(new Move(puchary, { yaw: 0.02, pitch: 0.6 }, {}, "Parter"));
    winda.addHotspot(new Move(piwnica, { yaw: 0.02, pitch: 0.7 }, {}, "Piwnica"));


    pietro_korytarz5.addHotspot(new Move(sala_215, { yaw: -0.06130361436087206, pitch: 0.21067949938446517 }));
    pietro_korytarz5.addHotspot(new Move(pietro_korytarz3, { yaw: -1.5175830130389674, pitch: 0.026780455788962598 }));
    pietro_korytarz5.addHotspot(new Move(pietro_korytarz2, { yaw: 1.027165349245676, pitch: 0.017238920801956326 }));
    pietro_korytarz5.addHotspot(new Move(pietro_korytarz4, { yaw: 1.8185404767035873, pitch: 0.006788826311012741 }));

    //Modals

    const stolik_srodek = new ModalImageFull(null, null, "stolik_srodek", setModal)
    const L1 = new ModalImageFull(null, null, "L1", setModal)
    const L2 = new ModalImageFull(null, null, "L2", setModal)
    const L3 = new ModalImageFull(null, null, "L3", setModal)
    const L4 = new ModalImageFull(null, null, "L4", setModal)
    const L5 = new ModalImageFull("Reprodukcja banknotu o nominale 50 zł", `Dar przedstawicieli chojnickiego oddziału
    Banku PKO. W gablocie można też zobaczyć autentyczny banknot o tym nominale.`, "L5", setModal)
    const L6 = new ModalImageFull(null, null, "L6", setModal)
    const P1 = new ModalImageFull("Różaniec z nieregularnych pereł", `Poświęcony przez papieża Benedykta XVI, następcę
    Jana Pawła II. Jest darem siostry Karoliny Słomińskiej SAC (pallotynki, pracującej w naszej
    szkole jako katechetka).`, "P1", setModal)
    const P2 = new ModalImageFull(null, null, "P2", setModal)
    const P3 = new ModalImageFull(null, null, "P3", setModal)
    const P4 = new ModalImageFull(null, null, "P4", setModal)
    const P5 = new ModalImageFull(null, null, "P5", setModal)
    const P6 = new ModalImageFull(null, null, "P6", setModal)
    const monetyzdjecie = new ModalImageFull(null, null, "gmedal", setModal)
    const stary_sztandar = new ModalImageFull(null, null, "stary_sztandar", setModal)
    const nowy_sztandar = new ModalImageFull(null, null, "nowy_sztandar", setModal)
    const monety = new ModalDetails( [
      {
    
      title : "Medal z Holandii",
      object : <Medal1 position={[0, 0, 0]} rotation={[1.5, 1.7, 0]} scale={[2,2,2]}/>,
      voice : "medal_z_holandii.wav"
    },
      {
      title : "Medal z pielgrzymki",
      object : <Medal5 position={[0, 0, 0]} rotation={[1.5, 1.7, 0]} scale={[2,2,2]}/>,
      voice : "medal_z_delegacji.wav"

    },
      {
      title : "Medal z pielgrzymki w Pelplinie",
      object : <Medal3 position={[0, 0, 0]} rotation={[1.5, 1.7, 0]} scale={[2,2,2]}/>,
      voice : "pelplin.wav"

    },
      {
      title : "Medal z okazji kanonizacji",
      object : <Medal4 position={[0, 0, 0]} rotation={[1.5, 1.7, 0]} scale={[2,2,2]}/>,
      voice : "tutu.wav"
    },
      {
      title : "Medal menniczy",
      object : <Medal2 position={[0, 0, 0]} rotation={[1.5, 1.7, 0]} scale={[2,2,2]}/>,
      voice : "ostatni.wav"
    },
  ], setModal)
    const banknot = new ModalDetails( [
      {
    
      title : "Reprodukcja banknotu o nominale 50 zł",
      object : <Banknot position={[0, 0, 0]} rotation={[1.5, 0, 0]} scale={[1.5,1.5,1.5]}/>,
      desc : `Dar przedstawicieli chojnickiego oddziału
      Banku PKO. W gablocie można też zobaczyć autentyczny banknot o tym nominale.`,
      voice : null
    },
    
  ], setModal)

    const piuska = new ModalImageFull("Piuska Jana Pawła II", `Najcenniejszy eksponat w Szkolnej Izbie Pamięci. Jest relikwią II
    stopnia, czyli przedmiotem, którym osobiście posługiwał się papież. Dowodem jej
    autentyczności jest tzw. sucha pieczęć widoczna na jej brzegu. Piuska trafiła do naszej szkoły
    dzięki staraniom siostry Haliny Lipińskiej SAC (pallotynki), pracującej w naszej szkole jako
    katechetka. Dzięki nawiązanym przez nią kontaktom ks. Mirosław Drozdek SAC (pallotyn),
    który był wówczas kustoszem Sanktuarium Matki Bożej Fatimskiej na Krzeptówkach w
    Zakopanem i miał do dyspozycji różne pamiątki po Janie Pawle II, ofiarował ją osobiście w
    marcu 2006 roku szkolnej delegacji nauczycieli i uczniów na czele z panią wicedyrektor
    Joanną Loll. Zachowały się zdjęcia z tego wydarzenia. Wiszą w Szkolnej Izbie Pamięci.`, "piuska", setModal)

    pamiec1.addHotspot(new Details(stolik_srodek, { yaw: -0.06351812236109744, pitch: 0.5431493083033274 }, setModal));

    pamiec1.addHotspot(new Details(L1, {yaw: -2.102303285192054, pitch: 0.27011437638003024}, setModal));
    pamiec1.addHotspot(new Details(L2, {yaw: -1.6408944251686535, pitch: 0.30143471847301306}, setModal));
    pamiec1.addHotspot(new Details(L3,{yaw: -1.1727505626113093, pitch: 0.2712423738538739}, setModal));
    pamiec1.addHotspot(new Details(L4, {yaw: -0.853841873596096, pitch: 0.23}, setModal));
    pamiec1.addHotspot(new Details(L5, {yaw: -0.6413625864514003, pitch: 0.1637812377610726}, setModal));
    pamiec1.addHotspot(new Details(L6, {yaw: -0.5031841748808397, pitch: 0.11677505238608646}, setModal));
    pamiec1.addHotspot(new Details(piuska, {yaw: -0.30, pitch: 0.18}, setModal));
    pamiec1.addHotspot(new Details(P1, {yaw: 1.9726705489630483, pitch: 0.2221572437705639}, setModal));
    pamiec1.addHotspot(new Details(P2, {yaw: 1.5610331269742357, pitch: 0.25}, setModal));
    pamiec1.addHotspot(new Details(P3, {yaw: 1.0917977183680705, pitch: 0.22}, setModal));
    pamiec1.addHotspot(new Details(P4, {yaw: 0.7691115285502654, pitch: 0.18829380546883144}, setModal));
    pamiec1.addHotspot(new Details(P5, {yaw: 0.5788424519766604, pitch: 0.1393259928047499}, setModal));
    pamiec1.addHotspot(new Details(P6, {yaw: 0.4443760879153622, pitch: 0.09927808991993814}, setModal));
    pamiec1.addHotspot(new Details(monety, {yaw: -0.012387850792327626, pitch: 0.150401619263206783}      , setModal));
    pamiec1.addHotspot(new Details(monetyzdjecie, {yaw: 0.23042371545664508, pitch: 0.15013329550694755}      , setModal));
    pamiec1.addHotspot(new Details(stary_sztandar, {yaw: 2.938680192238281, pitch: -0.6230795140038126}, setModal));
    pamiec1.addHotspot(new Details(nowy_sztandar, {yaw: 0.3279730683561404, pitch: -0.06792171192467045}, setModal));
    pamiec1.addHotspot(new Details(banknot, {yaw: -1.94090242830546, pitch: -0.1091324556160096}      , setModal));
    pamiec1.addHotspot(new Details(banknot, {yaw: -0.6666820256397337, pitch: -0.07811514849683654}     , setModal));

    // pamiec1.addHotspot(new Details(new ModalDetails("Banknot: 50zł Jan Paweł II", "Tu pojawi się opis ", null, setModal), { yaw: 1.28, pitch: -0.12 }, setModal));

    // pamiec1.addHotspot(new Details(new ModalDetails("Sztandar (Stary)", "Tu pojawi się opis ", null, setModal), { yaw: -.2, pitch: -0.55 }, setModal));

    // pamiec1.addHotspot(new Details(new ModalDetails("Skan 3D", "Tu pojawi się opis ", null, setModal), { yaw: -3.23, pitch: 0.55 }, setModal));

    // pamiec1.addHotspot(new Details(new ModalDetails("Monety", "Tu pojawi się opis ", null, setModal), { yaw: -3.1, pitch: .13 }, setModal));

    // pamiec1.addHotspot(new Details(new ModalDetails("Piuska Jana Pawła II", "Tu pojawi się opis ", null, setModal), { yaw: 2.84, pitch: 0.17 }, setModal));

    // pamiec1.addHotspot(new Details(new ModalDetails("Piuska Jana Pawła II", "Tu pojawi się opis ", null, setModal), { yaw: 3.45, pitch: -0 }, setModal));
    // pamiec1.addHotspot(new Details(new ModalDetails("Piuska Jana Pawła II", "Tu pojawi się opis ", null, setModal), { yaw: 2.0000000000000004, pitch: 0.25 }, setModal));

    pamiec1.loadScene();
    setViewer(viewer);



  }, []);



  return (
    <div id="marzipano" className='overflow-hidden' style={{ width: '100vw', height: '100vh' }} onClick={(e) => {
      console.log(actualScene.params.view.screenToCoordinates({ x: e.clientX, y: e.clientY }));

    }}>
      <SceneList remove={false} variation='left' title={"Ciekawe miejsca"} actualScene={actualScene} scenes={scenes} className='fixed z-50 p-2 flex flex-col gap-2 right-0' expanded={false}></SceneList>
      <div id='modal-container' className={`w-screen h-screen fixed top-0 left-0 bg-black bg-opacity-40 z-[100000000] ${modal === null ? "hidden" : ""}`}>
        {modal}
      </div>
      {actualScene?.createMenu()}
    </div>
  );
};



export default MarzipanoViewer;
